import Vue from "vue";
import Vuex from "vuex";
import custom from "./modules/custom";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    custom
  }
});

export default store;
